import {Injectable} from '@angular/core';
import {Actions, createEffect, ofType} from '@ngrx/effects';
import {switchMap, map} from 'rxjs/operators';
import {of} from 'rxjs';
import {catchError} from 'rxjs/operators';
import { SnackBarService } from '@core/services/snack-bar.service';
import { Go } from '@shared/store/actions/router-extension.action';
import {EntityChartConfig} from '../../entity-chart-config';
import { FuseSplashScreenService } from '@barebone-fuse-services/splash-screen.service';
import {Observable} from 'rxjs';
import {
  ENTITY_DATA_TEMPLATE_DOWNLOAD,
  ENTITY_IMPORT, ENTITY_IMPORT_SUCCESS,
  ENTITY_UPLOAD_SOURCE_FILE, EntityDataTemplateDownloadAction, EntityDataTemplateDownloadFailedAction,
  EntityDataTemplateDownloadSuccessAction,
  EntityImportAction, EntityImportFailAction,
  EntityImportSuccessAction,
  EntityUploadSourceFileAction, EntityUploadSourceFileFailedAction
} from '../actions/entity-chart.actions';
import {EntityImportCommand} from '../../commands/entity-chart.commands';
import { FileManagementService } from '@core/services/file-management.service';
import { CommandService } from '@core/services/command.service';

@Injectable()
export class EntityChartImportExportEffect {
  constructor(private actions$: Actions,
              private fileManagementService: FileManagementService,
              private commandService: CommandService,
              private snackBarService: SnackBarService,
              private fuseSplashScreenService: FuseSplashScreenService) {
  }


  contactUploadSourceFile$ = createEffect(() => this.actions$
    .pipe( ofType(ENTITY_UPLOAD_SOURCE_FILE) )
    .pipe(
      switchMap((action: EntityUploadSourceFileAction) => {
        this.fuseSplashScreenService.show();
        return this.fileManagementService.uploadFileWithRelativePath(action.file, action.path, action.overwrite)
          .pipe(
            map(fileId => {
              return new EntityImportAction(new EntityImportCommand(fileId, action.replaceExistingSelection));
            }),
            catchError(error => {
              this.fuseSplashScreenService.hide();
              this.snackBarService.showError('Entity Chart Import Failed');
              return of(new EntityUploadSourceFileFailedAction(error));
            })
          );
      })
    ));


  contactImport$ = createEffect(() => this.actions$
    .pipe( ofType(ENTITY_IMPORT) )
    .pipe(
      switchMap((action: EntityImportAction) => {
        return this.commandService.executeCommand(action.command)
          .pipe(
            map(entityImportNotification => {
              return new EntityImportSuccessAction(entityImportNotification.Payload);
            }),
            catchError(error => {
              this.fuseSplashScreenService.hide();
              this.snackBarService.showError('Entity Chart Import Failed');
              return of(new EntityImportFailAction(error));
            })
          );
      })
    ));


  contactImportSuccess$ = createEffect(() => this.actions$
    .pipe( ofType(ENTITY_IMPORT_SUCCESS) )
    .pipe(
      map(action => {
        this.fuseSplashScreenService.hide();
        this.snackBarService.showInformation('Entity Chart Imported');
        return new Go({path: EntityChartConfig.EntityChartUrl});
      })
    ));


  contactTemplateDownload$ = createEffect(() => this.actions$
    .pipe( ofType(ENTITY_DATA_TEMPLATE_DOWNLOAD) )
    .pipe(
      switchMap((action: EntityDataTemplateDownloadAction) => {
        return this.fileManagementService.downloadTemplate(action.fileName)
          .pipe(
            map((payload: any) => {
              // TODO: same code. move in a function
              const url = window.URL.createObjectURL(payload);
              const a = document.createElement('a');
              a.setAttribute('href', url);
              a.setAttribute('target', '_blank');
              a.setAttribute('download', 'Entity Data Template.xlsx');
              a.style.display = 'none';
              document.body.appendChild(a);
              a.click();
              document.body.removeChild(a);
              return new EntityDataTemplateDownloadSuccessAction();
            }),
            catchError(error => of(new EntityDataTemplateDownloadFailedAction(error)))
          );
      })
    ));
}

